export const USER_DOCS_NAME = 'users'
export const NEWS_DOCS_NAME = 'news'
export const SPACE_DOCS_NAME = 'spaces'
export const EVENT_DOCS_NAME = 'events'
export const CHUNK_DOCS_NAME = 'chunks'
export const REVIEW_DOCS_NAME = 'reviews'
export const OBJECTION_DOCS_NAME = 'objections'
export const USERS_DOCS_NAME = 'users'

export const CHUNK_DOC_FIELD_LIMIT = 50